import React, { ComponentProps } from 'react';
import { ContentList, ContentListItem } from '../../_lib/components/ContentList';
import ILink from '../../types/ILink';
import { asBlock } from '../../_lib/BlockFetcher';
import { BlockType } from '../../types/api/ElementType';
import { ContentHeadline } from '../../_lib/components/ContentHeadline';
import { murmurhash } from '../../lib/js/hash';
import { ContentParagraph } from '../../_lib/components/ContentParagraph';
import { useSonTranslation } from '../../translation/useSonTranslation';
import { ContentHeadlineModifier } from '../../_lib/components/ContentHeadline/ContentHeadline';

type UserToPageRoleListItem = {
  roleName: string;
  editLink: ILink;
  description: string;
  forPageTypes: string[];
};

export type UserToPageRolesListProps = {
  roles: UserToPageRoleListItem[];
};

/**
 * Linked list of all role with name and description.
 */
function UserToPageRolesList({ roles }: UserToPageRolesListProps) {
  const { t } = useSonTranslation('RoleList');

  if (roles?.length === 0) {
    return null;
  }

  return (
    <>
      <div className="roles-list__headline-container roles-list__headline-container--no-top-border">
        <ContentHeadline
          title={t('userToPage')}
          hierarchy={2}
          modifier={[ContentHeadlineModifier.LARGE, ContentHeadlineModifier.NO_MARGIN_BOTTOM]}
        />
      </div>
      <ContentList ordered>
        {roles.map(roleItem => {
          return (
            <ContentListItem key={roleItem.editLink.url}>
              <ContentHeadline
                title={roleItem.roleName}
                url={roleItem.editLink.url}
                hierarchy={3}
                modifier={ContentHeadlineModifier.TOP_HEADLINE}
                headingId={`user-to-page-role-list-heading-${murmurhash(roleItem.editLink.url)}`}
              />
              <ContentParagraph>{roleItem.description}</ContentParagraph>
              {roleItem.forPageTypes?.length > 0 ? (
                <ContentParagraph>
                  <dfn className="roles-list__dfn font-bold-15-19">{t('approvedFor')}:</dfn>{' '}
                  {roleItem.forPageTypes.map(pageType => t(`glossary:${pageType}` as any)).join(', ')}
                </ContentParagraph>
              ) : null}
            </ContentListItem>
          );
        })}
      </ContentList>
    </>
  );
}

export const UserToPageRolesListBlock = asBlock(UserToPageRolesList, BlockType.usertopageroleslist);
export type UserToPageRolesListBlock = ComponentProps<typeof UserToPageRolesListBlock>;
